/**
 * Styled Components - Created by cazarez on 02/05/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  &:hover{
    cursor: pointer;
  }
`

export const Text = styled.div`
  color: #fff;
`

export const Image = styled.img`
  cursor: pointer;
  width: 22px;
  @media (max-width: 1099px) {
    width: 18px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartForHeader/styledComponents.tsx